window.addEventListener('DOMContentLoaded', () => {
    const hideParentContainer = (el) => {
        el.style.visibility = 'hidden';
        el.style.height = '0';
    };
    const showParentContainer = (el) => {
        el.style.visibility = 'visible';
        el.style.height = 'auto';
    };
    // Grommets
    const customGrommetField = document.querySelector('input[name="custom_grommets_field"]');
    const customGrommetFieldParent = customGrommetField ? customGrommetField.closest('.calc-row') : null;
    const grommetDropdown = document.querySelector('select[name="grommets_field"]');
    // Pole Pocket
    const customPolePocketField = document.querySelector('input[name="custom_pole_pocket_field"]');
    const customPolePocketFieldParent = customPolePocketField ? customPolePocketField.closest('.calc-row') : null;
    const polePocketDropdown = document.querySelector('select[name="pole_pocket_field"]');
    if (customGrommetFieldParent && grommetDropdown && customPolePocketFieldParent && polePocketDropdown) {
        hideParentContainer(customGrommetFieldParent);
        hideParentContainer(customPolePocketFieldParent);
        grommetDropdown.addEventListener('change', e => {
            const target = e.target;
            const grommetSelectedOption = target.options[target.selectedIndex];
            const grommetLabel = grommetSelectedOption.getAttribute('data-label');
            if (grommetLabel === 'Custom Grommets') {
                showParentContainer(customGrommetFieldParent);
            } else {
                hideParentContainer(customGrommetFieldParent);
            }
        });

        polePocketDropdown.addEventListener('change', e => {
            const target = e.target;
            const polePocketSelectedOption = target.options[target.selectedIndex];
            const polePocketLabel = polePocketSelectedOption.getAttribute('data-label');
            if (polePocketLabel === 'Custom Pole Pocket') {
                showParentContainer(customPolePocketFieldParent);
            } else {
                hideParentContainer(customPolePocketFieldParent);
            }
        });

        navigation.addEventListener('navigate', (event) => {
            const url = new URL(event.destination.url);
            const newParam = url.searchParams.get('variant');
            setTimeout(() => {
                if (newParam) {
                    // Grommets
                    const currentCustomGrommetField = document.querySelector('input[name="custom_grommets_field"]');
                    const currentCustomGrommetFieldParent = currentCustomGrommetField ? currentCustomGrommetField.closest('.calc-row') : null;
                    const currentGrommetDropdown = document.querySelector('select[name="grommets_field"]');
                    hideParentContainer(currentCustomGrommetFieldParent);
                    currentGrommetDropdown.removeEventListener('change', e => {
                        const target = e.target;
                        const grommetSelectedOption = target.options[target.selectedIndex];
                        const grommetLabel = grommetSelectedOption.getAttribute('data-label');
                        if (grommetLabel === 'Custom Grommets') {
                            showParentContainer(currentCustomGrommetFieldParent);
                        } else {
                            hideParentContainer(currentCustomGrommetFieldParent);
                        }
                    });
                    currentGrommetDropdown.addEventListener('change', e => {
                        const target = e.target;
                        const grommetSelectedOption = target.options[target.selectedIndex];
                        const grommetLabel = grommetSelectedOption.getAttribute('data-label');
                        if (grommetLabel === 'Custom Grommets') {
                            showParentContainer(currentCustomGrommetFieldParent);
                        } else {
                            hideParentContainer(currentCustomGrommetFieldParent);
                        }
                    });

                    // Pole Pockets
                    const currentCustomPolePocketField = document.querySelector('input[name="custom_pole_pocket_field"]');
                    const currentCustomPolePocketFieldParent = currentCustomPolePocketField ? currentCustomPolePocketField.closest('.calc-row') : null;
                    const currentPolePocketDropdown = document.querySelector('select[name="pole_pocket_field"]');
                    hideParentContainer(currentCustomPolePocketFieldParent);
                    currentPolePocketDropdown.removeEventListener('change', e => {
                        const target = e.target;
                        const polePocketSelectedOption = target.options[target.selectedIndex];
                        const polePocketLabel = polePocketSelectedOption.getAttribute('data-label');
                        if (polePocketLabel === 'Custom Pole Pocket') {
                            showParentContainer(currentCustomPolePocketFieldParent);
                        } else {
                            hideParentContainer(currentCustomPolePocketFieldParent);
                        }
                    });
                    currentPolePocketDropdown.addEventListener('change', e => {
                        const target = e.target;
                        const polePocketSelectedOption = target.options[target.selectedIndex];
                        const polePocketLabel = polePocketSelectedOption.getAttribute('data-label');
                        if (polePocketLabel === 'Custom Pole Pocket') {
                            showParentContainer(currentCustomPolePocketFieldParent);
                        } else {
                            hideParentContainer(currentCustomPolePocketFieldParent);
                        }
                    });
                }
            }, 250);
        });
    }

});




/**
 * HBS product-page bridge.
 * Keeps the Orichi display, visible per-unit price, CTA hierarchy, and resource
 * links synchronized without changing any Shopify or app pricing.
 */
(() => {
  if (window.HBSProductDynamicUI) return;
  window.HBSProductDynamicUI = true;

  const PRODUCT_ROOT_SELECTOR = '.sf-prod__info, .sf-product__section, main';
  const QUANTITY_SELECTOR = 'input[name="quantity"]';
  const VARIANT_SELECTOR = [
    'input[name="id"]',
    'select[name="id"]',
    'select[name^="options"]',
    'input[type="radio"][name^="options"]'
  ].join(',');

  let lastVariantId = null;
  let lastQuantity = null;
  let refreshController = null;
  let syncTimer = null;
  let unsubscribeVariantEvent = null;
  let selectedVariant = null;

  const visible = (element) => {
    if (!element) return false;
    if (element.ownerDocument !== document) return true;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };

  const productRoot = () => document.querySelector('.sf-prod__info') || document.querySelector('main') || document;

  const textMatches = (element, expression) => {
    const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
    return expression.test(text);
  };

  const findSmallestTextElement = (root, expression) => {
    const matches = [...root.querySelectorAll('div, p, span, strong')]
      .filter((element) => visible(element) && textMatches(element, expression));
    return matches.sort((a, b) => (a.textContent || '').length - (b.textContent || '').length)[0] || null;
  };

  const findDiscountWidget = (root = document) => {
    const direct = [...root.querySelectorAll(
      '[data-orichi], [id*="orichi" i], [class*="orichi" i], [id*="quantity-break" i], [class*="quantity-break" i]'
    )].filter((element) => /Buy\s+\d+\+/i.test(element.textContent || '') && /\/\s*each/i.test(element.textContent || ''));

    if (direct.length) {
      return direct.sort((a, b) => (a.textContent || '').length - (b.textContent || '').length)[0];
    }

    const heading = findSmallestTextElement(root, /Buy more,\s*save more!/i);
    if (!heading) return null;

    let container = heading.parentElement;
    while (container && container !== root && !/Buy\s+\d+\+/i.test(container.textContent || '')) {
      container = container.parentElement;
    }
    return container && /\/\s*each/i.test(container.textContent || '') ? container : null;
  };

  const getTierRows = (widget) => {
    if (!widget) return [];
    const rows = [...widget.querySelectorAll('tr, [role="row"], li, div')]
      .map((element) => {
        const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
        const match = text.match(/Buy\s+(\d+)\+\s+\$?([\d,.]+)\s*(?:USD)?\s*\/\s*each/i);
        if (!match) return null;
        return {
          minimum: Number.parseInt(match[1], 10),
          price: Number.parseFloat(match[2].replace(/,/g, '')),
          element
        };
      })
      .filter(Boolean);

    if (!rows.length) {
      const text = (widget.textContent || '').replace(/\s+/g, ' ').trim();
      const expression = /Buy\s*(\d+)\+\s*\$?([\d,.]+)\s*(?:USD)?\s*\/\s*each/gi;
      let match;
      while ((match = expression.exec(text)) !== null) {
        rows.push({
          minimum: Number.parseInt(match[1], 10),
          price: Number.parseFloat(match[2].replace(/,/g, '')),
          element: null
        });
      }
    }

    const unique = new Map();
    rows.forEach((row) => {
      const current = unique.get(row.minimum);
      const rowLength = row.element ? (row.element.textContent || '').length : Number.POSITIVE_INFINITY;
      const currentLength = current && current.element
        ? (current.element.textContent || '').length
        : Number.POSITIVE_INFINITY;
      if (!current || rowLength < currentLength) {
        unique.set(row.minimum, row);
      }
    });
    return [...unique.values()].sort((a, b) => a.minimum - b.minimum);
  };

  const getQuantity = () => {
    const root = productRoot();
    const input = [...root.querySelectorAll(QUANTITY_SELECTOR)]
      .find((candidate) => visible(candidate) && !candidate.disabled);
    const quantity = Number.parseInt(input ? input.value : '1', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  };

  const getUnitPriceElement = () => {
    const root = productRoot();
    return findSmallestTextElement(
      root,
      /^(?:Final|Unit) price\s*:\s*\$?[\d,.]+(?:\s*(?:USD|ea\.?|\/\s*each))?$/i
    );
  };

  const formatPrice = (price) => `$${price.toFixed(2)} ea.`;

  const displayedProductPriceElement = () => {
    const root = productRoot();
    const unitPrice = getUnitPriceElement();
    const productTitle = [...root.querySelectorAll('h1')]
      .find((element) => visible(element));
    if (!productTitle) return null;

    const candidates = [...root.querySelectorAll(
      '.f-price-item--sale, .f-price-item--regular, [data-product-price], .product__price, .prod__price, span, p, div'
    )]
      .filter((element) => {
        const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
        const followsTitle = Boolean(
          productTitle.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING
        );
        return followsTitle
          && /^(?:Unit Price:\s*)?\$[\d,.]+\s*(?:USD)?(?:\s*ea\.)?$/i.test(text);
      })
      .sort((a, b) => (
        a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
      ));

    for (const element of candidates) {
      if (!visible(element) || element === unitPrice) continue;
      return element;
    }

    return null;
  };

  const restoreDiscountTableLabels = () => {
    const widget = findDiscountWidget();
    if (!widget) return;

    widget.querySelectorAll('span, p, div, td').forEach((element) => {
      const currentText = (element.textContent || '').replace(/\s+/g, ' ').trim();
      const match = currentText.match(/^Unit Price:\s*(\$[\d,.]+\s*(?:USD)?)\s*ea\.\s*\/\s*each$/i);
      if (match) element.textContent = `${match[1]} /each`;
    });
  };

  const decorateDisplayedProductPrice = () => {
    restoreDiscountTableLabels();
    const displayedPrice = displayedProductPriceElement();
    if (!displayedPrice) return;

    const obsoleteStyle = document.getElementById('hbs-live-unit-price-style');
    if (obsoleteStyle) obsoleteStyle.remove();
    displayedPrice.classList.remove('hbs-live-unit-price');

    const priceMatch = (displayedPrice.textContent || '').replace(/,/g, '').match(/\$[\d.]+\s*(?:USD)?/i);
    if (priceMatch) {
      const nextText = `${priceMatch[0]} ea.`;
      if (displayedPrice.textContent.trim() !== nextText) displayedPrice.textContent = nextText;
    }

    const duplicateUnitPrice = getUnitPriceElement();
    if (duplicateUnitPrice && duplicateUnitPrice !== displayedPrice) {
      duplicateUnitPrice.hidden = true;
      duplicateUnitPrice.setAttribute('aria-hidden', 'true');
    }
  };

  const productId = () => {
    const variantPicker = document.querySelector('[data-variant-picker], variant-picker[data-product-id]');
    const productForm = document.querySelector(
      '.sf-prod__info .product-form[data-product-id], .sf-prod__info form[data-product-id]'
    );
    return (variantPicker && variantPicker.dataset.productId)
      || (productForm && productForm.dataset.productId)
      || null;
  };

  const themeProduct = () => {
    const id = productId();
    return id && window._themeProducts ? window._themeProducts[id] : null;
  };

  const variantById = (variantId) => {
    const product = themeProduct();
    if (!product || !Array.isArray(product.variants) || !variantId) return null;
    return product.variants.find((variant) => String(variant.id) === String(variantId)) || null;
  };

  const currentVariant = () => selectedVariant || variantById(currentVariantId());

  const variantUnitPrice = (variant) => {
    const cents = variant && Number(variant.price);
    return Number.isFinite(cents) ? cents / 100 : null;
  };

  const tiersMatchVariant = (tiers, variant) => {
    const baseTier = tiers.find((tier) => tier.minimum === 1);
    const basePrice = variantUnitPrice(variant);
    return Boolean(
      baseTier
      && basePrice !== null
      && Math.abs(baseTier.price - basePrice) < 0.01
    );
  };

  const syncNativePrice = (variant) => {
    const price = variantUnitPrice(variant);
    if (price === null) return;

    const root = productRoot();
    const formatted = `$${price.toFixed(2)}`;
    const compareAtCents = variant && Number(variant.compare_at_price);
    const onSale = Number.isFinite(compareAtCents) && compareAtCents > Number(variant.price);
    const salePrices = [...root.querySelectorAll('.f-price-item--sale')];
    const regularPrices = [...root.querySelectorAll('.f-price-item--regular')];

    if (onSale) {
      const compareAt = `$${(compareAtCents / 100).toFixed(2)}`;
      salePrices.forEach((element) => {
        if (element.textContent.trim() !== formatted) element.textContent = formatted;
      });
      regularPrices.forEach((element) => {
        if (element.textContent.trim() !== compareAt) element.textContent = compareAt;
      });
      return;
    }

    [...salePrices, ...regularPrices].forEach((element) => {
      if (element.textContent.trim() !== formatted) element.textContent = formatted;
    });
  };

  const syncPriceAndTier = () => {
    const widget = findDiscountWidget();
    const tiers = getTierRows(widget);
    const quantity = getQuantity();
    const variant = currentVariant();
    const validTiers = tiersMatchVariant(tiers, variant);
    const activeTier = validTiers
      ? [...tiers].reverse().find((tier) => quantity >= tier.minimum)
      : null;

    tiers.forEach((tier) => {
      if (tier.element) {
        tier.element.classList.toggle('hbs-orichi-active-tier', tier === activeTier);
      }
    });

    decorateDisplayedProductPrice();
  };

  const decorateActions = () => {
    document.querySelectorAll('button, a, input[type="submit"]').forEach((element) => {
      const label = (element.textContent || element.value || '').replace(/\s+/g, ' ').trim();
      if (/^add to cart$/i.test(label)) element.classList.add('hbs-product-action--cart');
      if (/^request quote$/i.test(label)) element.classList.add('hbs-product-action--quote');
    });
  };

  const decorateResourceTabs = () => {
    const resources = [
      {
        selector: '[data-block-type="templates"] .product-tab-custom-graphic-files',
        text: 'Download the print-ready artwork template for your design team.'
      },
      {
        selector: '[data-block-type="specFiles"] .product-tab-custom-graphic-files',
        text: 'Share these customer-ready Spec Sheets directly with your client.'
      }
    ];

    resources.forEach(({ selector, text }) => {
      document.querySelectorAll(selector).forEach((container) => {
        if (container.closest('[data-block-type="specFiles"]')) {
          container.querySelectorAll('a > span').forEach((label) => {
            label.textContent = label.textContent
              .replace(/\bunbranded\b/gi, '')
              .replace(/\s{2,}/g, ' ')
              .trim();
          });
        }

        const parent = container.parentElement;
        if (!parent || parent.querySelector(':scope > .hbs-resource-intro')) return;
        const intro = document.createElement('p');
        intro.className = 'hbs-resource-intro';
        intro.textContent = text;
        parent.insertBefore(intro, container);
      });
    });
  };

  const currentVariantId = () => {
    const variantPicker = document.querySelector('variant-picker[data-variant-picker], variant-picker');
    if (variantPicker && variantPicker.currentVariant && variantPicker.currentVariant.id) {
      return String(variantPicker.currentVariant.id);
    }

    const fromUrl = new URL(window.location.href).searchParams.get('variant');
    if (fromUrl) return fromUrl;

    const productForm = document.querySelector(
      '.sf-prod__info form[action*="/cart/add"], .sf-prod__info form[data-type="add-to-cart-form"]'
    );
    const formInput = productForm && productForm.querySelector(
      'input[name="id"], select[name="id"]'
    );
    if (formInput && formInput.value) return formInput.value;

    const input = [...document.querySelectorAll('input[name="id"], select[name="id"]')]
      .find((candidate) => candidate.value && !candidate.disabled);
    return input ? input.value : null;
  };

  const notifyVariantConsumers = (variant) => {
    const variantId = String((variant && variant.id) || currentVariantId() || '');
    if (!variantId) return;
    selectedVariant = variant || variantById(variantId);
    const variantInput = [...document.querySelectorAll(
      'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
    )].find((input) => String(input.value) === variantId && !input.closest('variant-picker'));

    if (variantInput) {
      variantInput.dispatchEvent(new Event('input', { bubbles: true }));
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const detail = { variant, variantId };
    document.dispatchEvent(new CustomEvent('variant:change', { detail }));
    document.dispatchEvent(new CustomEvent('variant:changed', { detail }));
    window.dispatchEvent(new CustomEvent('product:variant-change', { detail }));

    [40, 120, 300, 700, 1400].forEach((delay) => {
      window.setTimeout(scheduleSync, delay);
    });
  };

  const refreshDiscountWidget = async (variantId) => {
    if (!variantId) return;
    if (refreshController) refreshController.abort();
    refreshController = new AbortController();

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: refreshController.signal
      });
      if (!response.ok) return;

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const currentWidget = findDiscountWidget(document);
      const nextWidget = findDiscountWidget(nextDocument);
      const nextTiers = getTierRows(nextWidget);
      const variant = variantById(variantId);

      if (
        currentWidget
        && nextWidget
        && tiersMatchVariant(nextTiers, variant)
        && currentWidget.innerHTML !== nextWidget.innerHTML
      ) {
        currentWidget.innerHTML = nextWidget.innerHTML;
      }
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('HBS quantity display refresh skipped.', error);
    } finally {
      window.setTimeout(syncPriceAndTier, 50);
    }
  };

  const scheduleSync = () => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(() => {
      decorateActions();
      decorateResourceTabs();
      syncPriceAndTier();
    }, 40);
  };

  const checkVariant = () => {
    const variantId = currentVariantId();
    if (!variantId || variantId === lastVariantId) return;
    const previous = lastVariantId;
    lastVariantId = variantId;
    selectedVariant = variantById(variantId);
    if (previous !== null) {
      [40, 120, 300, 700, 1400].forEach((delay) => {
        window.setTimeout(scheduleSync, delay);
      });
    }
    scheduleSync();
  };

  const checkQuantity = () => {
    const quantity = getQuantity();
    if (quantity === lastQuantity) return;
    lastQuantity = quantity;
    scheduleSync();
  };

  const initialize = () => {
    lastVariantId = currentVariantId();
    selectedVariant = variantById(lastVariantId);
    lastQuantity = getQuantity();
    scheduleSync();

    const currentProductId = productId();
    if (
      currentProductId &&
      window.MinimogEvents &&
      typeof window.MinimogEvents.subscribe === 'function'
    ) {
      unsubscribeVariantEvent = window.MinimogEvents.subscribe(
        `${currentProductId}__VARIANT_CHANGE`,
        (variant) => {
          if (!variant || !variant.id) return;
          selectedVariant = variant;
          lastVariantId = String(variant.id);
          [40, 120, 300, 700, 1400].forEach((delay) => {
            window.setTimeout(scheduleSync, delay);
          });
        }
      );
    }

    document.addEventListener('change', (event) => {
      if (event.target.matches(VARIANT_SELECTOR)) {
        window.setTimeout(checkVariant, 20);
        window.setTimeout(checkVariant, 250);
      }
      if (event.target.matches(QUANTITY_SELECTOR)) {
        lastQuantity = getQuantity();
        scheduleSync();
      }
    });

    document.addEventListener('input', (event) => {
      if (event.target.matches(QUANTITY_SELECTOR)) {
        lastQuantity = getQuantity();
        scheduleSync();
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest(
        '[data-quantity-selector], quantity-input button[name="minus"], quantity-input button[name="plus"], ' +
        '[data-quantity-minus], [data-quantity-plus], .quantity-decrease, .quantity-increase'
      )) {
        window.setTimeout(checkQuantity, 0);
        window.setTimeout(checkQuantity, 60);
        window.setTimeout(checkQuantity, 180);
      }
    });

    const observer = new MutationObserver(scheduleSync);
    observer.observe(document.querySelector(PRODUCT_ROOT_SELECTOR) || document.body, {
      childList: true,
      subtree: true
    });

    window.setInterval(() => {
      checkQuantity();
      checkVariant();
    }, 200);

    window.addEventListener('pagehide', () => {
      if (typeof unsubscribeVariantEvent === 'function') unsubscribeVariantEvent();
    }, { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
